import { render } from "./ContentTileScreen.vue?vue&type=template&id=06127386&scoped=true"
import script from "./ContentTileScreen.vue?vue&type=script&lang=js"
export * from "./ContentTileScreen.vue?vue&type=script&lang=js"

import "./ContentTileScreen.vue?vue&type=style&index=0&id=06127386&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06127386"]])

export default __exports__